import React from "react";

function Footer() {
  return (
    // <footer
    //   className="page-footer font-small text-black-50 d-flex justify-content-between align-items-center"
    //   style={fStyle}
    // >
    //   <span className="footer-copyright float-start">
    //     © {new Date().getFullYear()} Copyright by An Hoa Phu Trans . All rights
    //     reserved
    //   </span>
    // </footer>
    <div style={{ background: "white", fontSize: '13px', color: '#666', justifyContent: 'space-between', display: "flex", paddingTop: '10px', paddingBottom: '10px', paddingLeft: '15px', paddingRight: '15px' }}>
      <div>
        Hotline: <a href="tel:0906684184" style={{ color: '#0d6efd', textDecoration: 'none' }}>0906 684 184</a>
      </div>
      <div>© {new Date().getFullYear()} An Hoa Phu Transport</div>

    </div>
  );
}

export default Footer;
